import i18n from 'i18next';

function getDetectedLanguage() {
  return i18n.language.slice(0,2) || 'en';
}

export default getDetectedLanguage;
